export function getCurrentRole(playerId, captainId, viceId, deputyId) {
  if (playerId === null) return null;

  if (playerId === captainId) return "C";
  if (playerId === viceId) return "VC";
  if (playerId === deputyId) return "DVC";

  return null;
}
